import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import { TextField, Typography } from "@mui/material";

import { useTraining } from "../../contexts/training";
import ModalComponent from "../modal";
import Button from "../button";

export interface ITrainingSheetModalMethods {
  handleOpen: () => void;
}

const TrainingSheetModal = forwardRef<ITrainingSheetModalMethods>((_, ref) => {
  const { training, handleSaveTrainingSheet, saving } = useTraining();
  const [open, setOpen] = useState(false);
  const [objective, setObjective] = useState<string>(training?.objective || "");
  const [observation, setObservation] = useState<string>(
    training?.observation || ""
  );
  const [haveFocusInSomeInput, setHaveFocusInSomeInput] = useState(false);

  const handleCloseModal = useCallback(() => {
    if (!saving) {
      setOpen(false);
      setHaveFocusInSomeInput(false);
    }
  }, [saving]);

  const handleOpen: ITrainingSheetModalMethods["handleOpen"] =
    useCallback(() => {
      setOpen(true);
      setObjective(training?.objective || "");
      setObservation(training?.observation || "");
    }, [training]);

  useImperativeHandle(ref, () => ({ handleOpen }));

  return (
    <ModalComponent
      title="Training modal component"
      open={open}
      handleClose={() => (!haveFocusInSomeInput ? handleCloseModal() : {})}
    >
      <Typography>Objetivo</Typography>
      <TextField
        value={objective}
        onChange={(e) => setObjective(e.target.value)}
        sx={{ mt: 1, mb: 3 }}
        inputProps={{
          placeholder: "Objetivo do aluno...",
        }}
        size="small"
      />

      <Typography>Observação</Typography>
      <TextField
        inputProps={{
          placeholder: "Escreva observações nesse espaço...",
        }}
        multiline
        size="small"
        fullWidth
        rows={4}
        sx={{ mt: 1, mb: 3 }}
        onChange={(e) => setObservation(e.target.value)}
        value={observation}
        onFocus={() => setHaveFocusInSomeInput(true)}
        onBlur={() => {
          setTimeout(() => {
            setHaveFocusInSomeInput(false);
          }, 100);
        }}
      />

      <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={() =>
          handleSaveTrainingSheet(
            {
              observation,
              objective,
            } as never,
            handleCloseModal
          )
        }
        loading={saving}
        loadingText="Salvando..."
      >
        Salvar
      </Button>
      <Button
        sx={{ mt: 1 }}
        fullWidth
        variant="text"
        size="large"
        onClick={handleCloseModal}
        disabled={saving}
      >
        Voltar
      </Button>
    </ModalComponent>
  );
});

export default TrainingSheetModal;
